import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { CREATE_APP_PATH } from '../../utils/constants';

export default class AddAppAlert extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      visible: true
    };

    this.onDismiss = this.onDismiss.bind(this);
  }

  onDismiss() {
    this.setState({ visible: false });
    localStorage.setItem('hideNoAppAlert', 'yes');
  }

  render() {
    if (this.state.visible) {
      return (
        <Link to={CREATE_APP_PATH} className="add-app-alert">
          <p>Add your first APP</p>
          <span>Click here to add your first app</span>
          {/* <button className="close-add-app-alert" onClick={this.onDismiss}>
            <span className="lnr lnr-cross" />
          </button>*/}
        </Link>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/alert/AddAppAlert.js